import {
    all,
    put,
    SagaIterator,
    select,
    takeEvery,
    takeEveryCompletedRequest,
} from 'acscp/sagas/core/sagaEffects';
import { BookingViewOpened, SetAcsOfficeBasedContacts } from 'acscp/actions';
import { AppState, AuthState } from 'acscp/store';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { CustomerContactDetails } from 'acscp/api/models/customerContactDetails';
import { CustomerContactDetailsRequest } from 'acscp/api/requests';

export function* acsContactTelephoneNumberSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(CustomerContactDetailsRequest, handleContactDetailsUpdate),
        takeEvery(BookingViewOpened, handleBookingViewOpened),
    ]);
}

function* handleContactDetailsUpdate(response: CustomerContactDetails): SagaIterator {
    // prioritise the telephone number that's most relevant to the logged-in user
    yield put(new SetAcsOfficeBasedContacts(
        response.bestAcsContactTelephoneNumber || undefined,
        response.mainSiteLink || undefined
    ));
}

function* handleBookingViewOpened(action: BookingViewOpened): SagaIterator {
    const authState = (yield select((state: AppState) => state.auth)) as unknown as AuthState;

    if (!userIsLoggedIn(authState)) {
        yield put(new SetAcsOfficeBasedContacts(
            action.booking.enquiryOfficeTelephoneNumber || undefined,
            action.booking.mainSiteLink || undefined
        ));
    }
}
